export default __webpack_public_path__ + "static/media/ut.88dd4c2c.png";